// Estado visual: nunca concede permisos sobre tickets.
// El backend decide quien recibe cada evento.

export const pruneMetaCallAlerts = (alerts, now = Date.now()) => {
  if (!Array.isArray(alerts)) return [];

  return alerts.filter(item =>
    item &&
    typeof item.callId === "string" &&
    Number.isSafeInteger(item.ticketId) &&
    Number.isFinite(item.expiresAtMs) &&
    item.expiresAtMs > now
  ).slice(-5);
};

export const reduceMetaCallAlerts = (
  alerts,
  event,
  now = Date.now()
) => {
  const active = pruneMetaCallAlerts(alerts, now);

  if (
    !event ||
    typeof event !== "object" ||
    typeof event.callId !== "string" ||
    !event.callId ||
    event.callId.length > 256 ||
    event.callId.trim() !== event.callId
  ) {
    return active;
  }

  if (event.action === "ended") {
    return active.filter(item => item.callId !== event.callId);
  }

  if (event.action !== "ringing") return active;

  if (
    !Number.isSafeInteger(event.ticketId) ||
    event.ticketId <= 0 ||
    typeof event.expiresAt !== "string"
  ) {
    return active;
  }

  const expiresAtMs = Date.parse(event.expiresAt);

  if (!Number.isFinite(expiresAtMs) || expiresAtMs <= now) {
    return active;
  }

  // Una retransmision del mismo callId no duplica el aviso.
  // Mantener una sola llamada visible por conversacion.
  // Una llamada nueva reemplaza el aviso anterior.
  const remaining = active.filter(
    item =>
      item.callId !== event.callId &&
      item.ticketId !== event.ticketId
  );

  return [
    ...remaining,
    {
      callId: event.callId,
      ticketId: event.ticketId,
      expiresAtMs
    }
  ].slice(-5);
};
